/*@flow*/
import React from 'react';
import * as t from 'lib/t';
import enumsFor from './util/enumsFor';
import { Id } from 'types/tcomb';
import mkTagTemplate from 'lib/templates/mkTagTemplate';
import RecurrenceType from './types/Recurrence';
import { EventVenue } from 'lib/templates';
import isEmbedded from 'lib/isEmbedded';
import resource from '.';

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  contactable_id: t.maybe(Id).opt({ type: 'hidden' }),
  contactable_type: t.maybe(t.String).opt({ type: 'hidden' }),
  name: t.String.opt({
    attrs: {
      autoComplete: 'off',
    },
  }),
  address: t.maybe(t.String).options({
    template: 'LocationPickerTemplate',
  }),
  mapLabel: t.maybe(t.String),
  theGeom: t.String.options({ type: 'hidden' }),
  tenantId: t.maybe(Id).opt({
    template: EventVenue,
    label: 'Nearby Venues',
    attrs: { placeholder: 'Find a venue' },
    namespace: 'event',
    help: (
      <span className="form-text text-muted small">
        Note: This dropdown is populated with respect to the location of the
        event. To show nearby venues, you must first select a location.
      </span>
    ),
  }),
  locationName: t.maybe(t.String).opt({ label: 'Venue name' }),
  cost: t.maybe(t.Number).opt({
    label: 'Cost',
  }),
  visibility: enumsFor('visibility'),
  status: t.String.options({
    template: 'EventStatus',
    attrs: {
      placeholder: 'Choose status',
      classNamePrefix: 'Select',
    },
  }),
  recurrences: t.list(RecurrenceType).opt({
    label: 'Date & Time',
    template: 'RecurrenceTemplate',
  }),
  category: t.String.opt({
    template: 'EventCategory',
    attrs: {
      placeholder: 'Choose a category',
    },
  }),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('events'),
    attrs: {
      placeholder: 'Select...',
    },
  }),
  description: t.maybe(t.String).opt({
    type: 'textarea',
    template: 'TextEditorTemplate',
  }),
  photoUrls: t.maybe(t.list(t.String)).opt({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  photoCaption: t.maybe(t.String),
  url: t.maybe(t.String).opt({
    label: 'Website',
  }),
  registrationUrl: t.maybe(t.String).opt({
    label: 'Registration url',
  }),
  contactIds: t.maybe(t.list(Id)).opt({
    before: {
      tag: 'h3',
      props: { children: 'Associated Records', className: 'mt-5' },
    },
    after: {
      tag: 'div',
      props: { className: 'mb-5 mt-5' },
    },
    template: 'Contacts',
    label: 'Contacts',
    attrs: {
      placeholder: 'Select Contact',
      classNamePrefix: 'SelectRecordContacts',
    },
    hideWhen: isEmbedded,
  }),
};

export default t.struct(config, 'Event').opt<any>({ legend: '' });
